import { applicationsClient } from '@terra/shared-rest-clients-applications';
import { withOrchestratorClient } from '../clients/tester-client/api-core';
import { getAuthHeaders } from './authHeaders';

/**
 * Gracefully completes a manual crawler session on the backend.
 * Safe to call even if the session is already completed/failed.
 */
export async function completeManualSessionIfNeeded(
  applicationId: string | undefined,
  sessionId: string | undefined,
): Promise<void> {
  if (!applicationId || !sessionId) return;
  try {
    await applicationsClient.completeManualCrawlerSession({
      body: {},
      params: { id: applicationId, sessionId },
      ...withOrchestratorClient(await getAuthHeaders()),
    });
  } catch (err) {
    console.warn('Failed to complete manual crawler session:', err);
  }
}

export async function requestBatchParametrizationOnBrowserClosed(
  applicationId: string | undefined,
): Promise<void> {
  if (!applicationId) return;
  try {
    await applicationsClient.requestBatchParametrizationOnBrowserClosed({
      body: {},
      params: { id: applicationId },
      ...withOrchestratorClient(await getAuthHeaders()),
    });
  } catch (err) {
    console.warn(
      'Failed to request batch parametrization on browser close:',
      err,
    );
  }
}

/**
 * Fully stops an active tracking session:
 * 1. Stops the Electron main-process tracking session
 * 2. Completes the manual crawler session on the backend
 *
 * Called from store actions (app/company switch) so Electron and backend
 * are immediately cleaned up without relying on async sync hooks.
 */
export async function stopTrackingSession(
  applicationId: string | undefined,
  sessionId: string | undefined,
): Promise<void> {
  try {
    if (typeof window !== 'undefined' && window.electronAPI?.tracking) {
      await window.electronAPI.tracking.stop();
    }
  } catch (err) {
    console.warn('Failed to stop Electron tracking session:', err);
  }
  await completeManualSessionIfNeeded(applicationId, sessionId);
}
